/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/without.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Groups by all time-series dimensions except the specified ones. When called with no arguments, groups by all dimensions.
 *
 * @example
 * TS k8s
 * | STATS total_cost = sum(network.cost) BY WITHOUT(pod)
 * | SORT total_cost
 *
 * @example
 * TS k8s
 * | STATS total_cost = sum(network.cost) BY WITHOUT(pod, region)
 * | SORT total_cost
 *
 * @example
 * TS k8s
 * | STATS total_cost = sum(network.cost) BY WITHOUT()
 * | SORT total_cost
 */
const definition: FunctionDefinition = {
  type: 'grouping',
  name: 'without',
  signatures: [
    {
      params: [
        {
          name: 'dimension',
          type: 'keyword',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
